import * as React from "react";
import BaseModel from "../../models/BaseModel";
import WatchableValue from "../../models/WatchableValue";
import { useOnChangeWatcher } from "../../models/useOnChangeWatcher";
import UniversalObjectTableRow from "./UniversalObjectTableRow";
import type { AdditionalColumnConfig, ColumnConfig } from "./UniversalObjectTable";

export type UniversalObjectTableRowsProps = {
  objects: WatchableValue<BaseModel[]>;
  selectedObjects?: WatchableValue<Set<BaseModel>>;
  onSelectionChange?: () => void;
  additionalColumns?: AdditionalColumnConfig[];
  grandparentColumnConfig?: ColumnConfig;
  parentColumnConfig?: ColumnConfig;
  objectColumnConfig: ColumnConfig;
  onUnlink?: (obj: BaseModel | undefined) => void;
};

export default function UniversalObjectTableRows(props: UniversalObjectTableRowsProps) {
  const {
    objects,
    selectedObjects,
    onSelectionChange,
    additionalColumns,
    grandparentColumnConfig,
    parentColumnConfig,
    objectColumnConfig,
    onUnlink,
  } = props;

  const refTop = React.useRef<HTMLDivElement>(null);

  function onScroll(e: React.UIEvent<HTMLDivElement>) {
    const scrollLeft = e.currentTarget.scrollLeft;

    if (refTop.current) {
      const header = refTop.current.parentElement?.querySelector("#UniversalObjectTableHeaderRow") as HTMLElement; // no itx
      if (header) {
        header.style.marginLeft = `-${scrollLeft}px`;
        header.style.width = `${refTop.current.clientWidth + scrollLeft}px`;
      }
    }
  }

  useOnChangeWatcher(objects);
  useOnChangeWatcher(selectedObjects);

  return (
    <div
      ref={refTop}
      id="UniversalObjectTableRows"
      className="estadaColumn w100 h100 left"
      style={{ overflow: "auto", minHeight: "20px", flexGrow: "1" }}
      onScroll={onScroll}
    >
      {objects.value.map((obj) => (
        <UniversalObjectTableRow
          key={obj?.id}
          obj={obj as BaseModel}
          selectedObjects={selectedObjects}
          onSelectionChange={onSelectionChange}
          additionalColumns={additionalColumns}
          grandparentColumnConfig={grandparentColumnConfig}
          parentColumnConfig={parentColumnConfig}
          objectColumnConfig={objectColumnConfig}
          onUnlink={onUnlink}
        />
      ))}
    </div>
  );
}
